<template>
  <div>
    <van-nav-bar
        title="消息通知"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    />

    <div class="body">
      <van-tabs  @change="changeTab">
        <van-tab v-for="s in status" :title="s.name"  :name="s.value" :key="s.name">
          <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="loadMore"
          >
            <van-cell v-for="item in data" :key="item.id"  :label="item.summary"  :value="item.createdTime" @click="open(item.id)">
              <template #title>
                <span class="custom-title" v-text="item.title">单元格</span>
                <van-tag :type="item.unread?'danger':'success'" >{{item.unread?'未读':'已读'}}</van-tag>
              </template>
            </van-cell>
          </van-list>
        </van-tab>
      </van-tabs>

    </div>
  </div>
</template>

<script>
import {findAll,get} from "@/api/notice";
import {Dialog} from "vant";
export default {
  data(){
    return {
      loading:false,
      finished:false,
      params:{
        page:-1,
        size:20,
        unread:true
      },
      data:[],
      status:[
        {
          name:'未读',
          value:'true'
        },
        {
          name:'已读',
          value:'false'
        },
        {
          name:'全部',
          value:'0'
        }
      ]
    }
  },
  methods:{
    async loadData(){
      this.loading = true
      let d = (await findAll(this.params)).data;
      this.loading = false
      this.data = d.content;
      this.finished = d.isLast;
    },
    loadMore() {
      if(!this.finished){
        this.params.page++;
        this.loadData()
      }
    },
    changeTab(v){
      this.params.unread = v==0?undefined:v
      this.params.page=0;
      this.loadData()
    },
    async open(id){
      let d = (await get(id)).data
      Dialog.confirm({
        title: d.title,
        message: d.description,
        theme: 'round-button',
        showCancelButton:false,
        confirmButtonText:"关闭"
      })
          .then(() => {
          })
          .catch(() => {
            // on cancel
          });
    }
  }
}
</script>
<style lang="less" scoped>
.body {
  margin: 60px 0;
}
.custom-title{
  margin-right: 0.5em;
}

</style>